import { module } from 'modujs'
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { VueReCaptcha } from 'vue-recaptcha-v3'

export default class extends module {
    constructor(m) {
        super(m)

        this.sitekey = window.app?.recaptchaPublicKey;
    }

    init() {
        const moduleInstance = this;

        const guestCountMax = 2

        this.app = createApp({
            delimiters: [ '${', '}' ],
            data: () => ({
                eventId: null,
                eventTitle: '',
                eventDates: [],
                firstName: '',
                lastName: '',
                email: '',
                date: '',
                guestCount: 1,
                isHotelGuest: false,
                reservationNumber: '',
                groupingCode: '',
                message: '',
                isSubmitted: false,
                isError: false
            }),
            methods: {
                addGuest() {
                    if (this.guestCount < guestCountMax) {
                        this.guestCount++
                    }
                },
                substractGuest() {
                    if (this.guestCount > 1) {
                        this.guestCount--
                    }
                },
                getFormattedDate(date) {
                    const day = date.getDate()
                    const month = date.getMonth() + 1
                    const year = date.getFullYear()

                    return `${month}/${day}/${year}`
                },
                isDateDisabled(date) {
                    if (date.available.public) {
                        return false;
                    }

                    if (date.available.guests) {
                        return this.isHotelGuest != 'true';
                    }

                    return true;
                },
                async submit(event) {
                    this.resetStates()

                    const formAction = event.target.action
                    const formMethod = event?.target?.method ?? 'GET'

                    if(!this.eventId) {
                        this.message = 'Missing event ID.'
                        return;
                    }

                    if(!formAction) {
                        this.message = 'An error happened. Missing API URL.'
                        return;
                    }

                    this.message = 'Submitting...'

                    // Retrieve data
                    const formData = new FormData(event.target);

                    // Add event data
                    formData.append('event', this.eventId);

                    // Add recaptcha
                    await this.$recaptchaLoaded()
                    const token = await this.$recaptcha()
                    formData.append('g-recaptcha-response', token);

                    // Fetch URL
                    fetch(formAction,
                        {
                            method: formMethod,
                            crossDomain: true,
                            credentials: 'same-origin',
                            mode: 'no-cors',
                            body: formData,
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(response => {
                            // Unsuccessful response.
                            if (response.status === 500) {
                                this.isError = true
                            }

                            return response.json()

                        })
                        .then(body => {
                            if (!body.success) {
                                if (body?.errors|length) {
                                    throw new Error(body?.errors[0].message)
                                }
                                throw new Error('An error happened, try again.')
                            }

                            this.isSubmitted = true
                        })
                        .catch(error => {
                            this.message = error.message
                        }
                    )
                },
                showErrorMessage() {
                    this.isError = true
                    this.message = 'Please select a date'
                },
                resetStates() {
                    this.isError = false
                    this.message = ''
                },
                resetForm() {
                    this.isSubmitted = false
                    this.message = ''

                    this.resetStates()

                    requestAnimationFrame(() => {
                        this.$refs.form.reset()

                        requestAnimationFrame(() => {
                            this.date = ''
                            this.firstName = ''
                            this.lastName = ''
                            this.email = ''
                            this.reservationNumber = ''
                            this.groupingCode = ''
                            this.isHotelGuest = false
                            this.guestCount = 1
                        })
                    })
                },
                onReceiveAttributes({ detail }) {
                    const { eventTitle, eventDates, eventId } = detail
                    this.eventTitle = eventTitle
                    this.eventDates = eventDates
                    this.eventId = eventId
                }
            },
            watch: {
                date(newDate, oldDate) {
                    if (newDate != null) this.resetStates()
                }
            },
            computed: {
            },
            mounted() {
                window.addEventListener('updateFormRsvpAttributes', this.onReceiveAttributes);
            },
            beforeDestroy() {
                // Clean up the event listener when the component is destroyed
                window.removeEventListener('updateFormRsvpAttributes', this.onReceiveAttributes);
            }
        })

        if (this.sitekey) {
            this.app.use(VueReCaptcha, { siteKey: this.sitekey })
        }

        this.app.mount(this.el)
    }
}
